import React, { Component } from 'react';
import { observer, Provider } from 'mobx-react';
import Aside from './components/aside';
import Canvas from './components/canvas';
import Api from './services/api';
import Data from './data/data';

const App = observer(
  class App extends Component {
    componentDidMount() {
      Data.init(Api);
    }
    render() {
      return (
        <Provider store={Data}>
          <div className='rootInner'>
            {Data.dataLoaded ? (
              <div className='bzk'>
                <Canvas />
                <Aside />
              </div>
            ) : (
              <div className='bzk-loader' role='status' aria-live='polite'>
                <i className='bzk-options__spinner' aria-hidden='true' />
                <span className='visually-hidden'>Data wordt geladen...</span>
              </div>
            )}
            <svg id='texts' />
          </div>
        </Provider>
      );
    }
  },
);

export default App;
